<template>
    <div class="flex flex-row-reverse w-full border-dashed border-pale-grey">
        <featured-media-component
            :media="article.featured_media"
            :link="article.link"
            :short-headline="article.short_headline"
            class="flex-shrink-0 w-116px h-116px sm:w-170px" />

        <div class="flex-1 flex flex-col text-right justify-between pt-2 pr-4">
            <a :href="article.link" 
                :title="article.short_headline"
                class="w-full h-full flex flex-col justify-between">

                <p class="leading-10 text-waheed text-xl lg:text-17px text-black-two hover:underline">
                    {{ article.short_headline }}
                </p>

                <article-meta-component 
                    :article="article" />
            </a>
        </div>
    </div>
</template>

<script>
import FeaturedMediaComponent from '../FeaturedMedia/FeaturedMediaComponent.vue'
import ArticleMetaComponent from '../ArticleMetaComponent.vue'

export default {
    props: {
        article: {
            type: Object
        }
    },
    components: {
        FeaturedMediaComponent,
        ArticleMetaComponent
    }
}
</script>